<template>
    <div class="icon" :class="bgSize" :style="[getBgColor, getBorderColor]">
        <font-awesome-icon :icon="icon" :color="color" :size="size"/>
    </div>
</template>

<script>
export default {
    props: ['icon', 'color', 'bgColor', 'borderColor', 'size', 'bgSize'],
    computed: {
        getBgColor() {
            return this.bgColor !== undefined
                    ? { backgroundColor: this.bgColor}
                    : { backgroundColor: 'transparent'}
        },
        getBorderColor() {
            return this.borderColor !== undefined
                ? { border: `1px solid ${this.borderColor}`, borderRadius: '100px'}
                : { border: 'unset'}
        }
    }
}
</script>

<style lang="scss">
    .icon{
        flex: 0 0 auto;
        display:flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        width: 30px;
        height: 30px;
        background:#fff;
        border-radius: 150px;

        &.sm{
            width: 20px;
            height: 20px
        }
    }
</style>